import { Component, OnInit, Input } from '@angular/core';
import { Location } from '@angular/common';
@Component({
    selector: 'svg-playing-card',
    templateUrl: './svg-playing-card.component.html',
    styleUrls: ['./svg-playing-card.component.scss'],
    standalone: false
})
export class SvgPlayingCardComponent implements OnInit {
    @Input() cardId: string;
    @Input() rabbitCard = false;
    @Input() rabbitCardBack = false;

    constructor(private location: Location) {}

    ngOnInit() {}

    getUrl(effect: string) {
        return `url(${this.location.path()}#${effect})`;
    }
}
